import type { ComponentPropsWithRef } from 'react';

import { CONTROL_BASE } from '@/components/ui/input';
import { cn } from '@/lib/cn';

export interface TextareaProps extends ComponentPropsWithRef<'textarea'> {
  invalid?: boolean;
}

export function Textarea({ invalid, className, rows = 4, ...props }: TextareaProps) {
  return (
    <textarea
      rows={rows}
      aria-invalid={invalid ? true : undefined}
      className={cn(
        CONTROL_BASE,
        'resize-y px-2 py-2 text-xs sm:py-1.5',
        invalid ? 'border-danger' : 'border-border-strong hover:border-content-subtle',
        className,
      )}
      {...props}
    />
  );
}
